import React from "react";

import { createSvgIconComponent } from "../utils";

export const IconClockTruck = createSvgIconComponent({
  viewBox: "0 0 24 24",
  children: (
    <>
      <circle cx="19.5" cy="19.5" r="1.7"></circle>
      <circle cx="9.5" cy="19.5" r="1.7"></circle>
      <path d="M5 10c2.7 0 5-2.3 5-5S7.7 0 5 0 0 2.3 0 5s2.3 5 5 5zM4 2.5c0-.3.2-.5.5-.5s.5.2.5.5V5h1.5c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5v-3zM3.5 14c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-3c-.3 0-.5.2-.5.5s.2.5.5.5h3zM3.5 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM3.5 17H3c-.3 0-.5.2-.5.5s.2.5.5.5h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM15.5 8h-5.3c-1.1 1.8-3 3.5-5.2 3.5v8c0 .1.1.3.1.4.1 0 .3.1.4.1h1.8c0-.2-.1-.3-.1-.5 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 .2 0 .4-.1.5h3.8c.3 0 .5-.2.5-.5v-11c.2-.3 0-.5-.3-.5zM24 16v-.2l-2.5-4.5c-.2-.2-.3-.3-.5-.3h-3.5c-.3 0-.5.2-.5.5v8c0 .2.1.4.3.5 0-.2-.1-.3-.1-.5 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 .2 0 .4-.1.5h1.8c.3 0 .5-.2.5-.5L24 16zm-6-1v-3h2.7l1.8 3H18z"></path>
    </>
  ),
});
